import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import "../../../../../assets/css/subscreens/customer/dashboard/apphome/apphomeservicesection/AppHomeServicesection.css";
import { useServiceWorkerContext } from '../../../../../context/workercontext/WorkerContext';

const OurServices = () => {
  const navigate = useNavigate();
  const { setSelectedWorker } = useServiceWorkerContext();

  const baseUrl = "http://localhost:8000/api";

  const [services, setServices] = useState([]);

  // Categories fetch
  const fetchCategories = () => {
    axios
      .get(`${baseUrl}/whadmin/viewAllCategory`)
      .then((response) => {
        // Sirf active categories show karo
        const activeCategories = response.data.category.filter(
          (cat) => cat.status === 1 || cat.status === true
        );

        setServices(activeCategories);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleClick = (service) => {
    setSelectedWorker(service.id);

    navigate('/professionals', {
      state: {
        categoryName: service.categoryName,
        categoryId: service.id,
      },
    });
  };

  return (
    <div className="sc-section">

      <div className="sc-header">
        <h2 className="sc-title">Select Category</h2>

        <button
          className="sc-view-all"
          onClick={() => navigate('/customer-category')}
        >
          View all <ArrowRight size={14} />
        </button>
      </div>

      <div className="sc-row">
        {services.map((service) => (
          <button
            key={service.id}
            className="sc-item"
            onClick={() => handleClick(service)}
          >
            <div className="sc-item__img-wrap">
              <img
                src={`http://localhost:8000/storage/${service.categoryImage}`}
                alt={service.categoryName}
                className="sc-item__img"
              />
            </div>

            <span className="sc-item__label">
              {service.categoryName}
            </span>
          </button>
        ))}
      </div>

    </div>
  );
};

export default OurServices;